import { TabsetConfig } from 'ngx-bootstrap/tabs';

export class NgxBootstrapTabsetConfigService {

    static getTabsetConfig(): TabsetConfig {
        return Object.assign(new TabsetConfig(), {
        });
    }
}
